import { styled as StyledMui } from "@mui/system";
import { Box, Fab } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export const ScrollContainerBox = StyledMui(Box)(({ isHeaderShrink }) => ({
  display: "grid",
  gridTemplateColumns: "1fr",
  justifyContent: "center",
  padding: "0",
  width: "100%",
  maxHeight:
    String(isHeaderShrink) === "true"
      ? "calc(100vh - 91px)"
      : "calc(100vh - 12.05vw)",
  overflowY: "scroll",
  overflowX: "hidden",
  scrollbarWidth: "auto",
  "::-webkit-scrollbar": { width: "0.7rem" },
  "@media only screen and (min-width: 1921px)": {
    maxHeight: String(isHeaderShrink) === "false" && "calc(100vh - 167px)",
  },
}));

export const StyledFab = StyledMui(Fab)(({ theme }) => ({
  position: "fixed",
  bottom: 16,
  right: theme.direction === "ltr" && 30,
  left: theme.direction === "rtl" && 30,
  backgroundColor: "#FFFFFF",
  "@media only screen and (min-width: 1921px)": {
    bottom: 40,
    right: theme.direction === "ltr" && "calc( ((100vw - 1800px) / 2) )",
    left: theme.direction === "rtl" && "calc( ((100vw - 1800px) / 2) )",
  },
}));

export const StyledKeyboardArrowUpIcon = StyledMui(KeyboardArrowUpIcon)(() => ({
  color: "#cf2030",
}));
